const MAX_INPUT_NUMBER = 1e8;
const MIN_INPUT_NUMBER = -MAX_INPUT_NUMBER;

const getNumberLimit = (condition: boolean | undefined) => {
  if (!condition) {
    return {
      max: undefined,
      min: undefined
    };
  }
  return {
    max: MAX_INPUT_NUMBER,
    min: MIN_INPUT_NUMBER
  };
};

const editLimit = <T extends string | number = string>(
  val: T,
  max?: number,
  min?: number
): T => {
  const isString = typeof val == 'string';
  if (isString && !val.trim()) {
    return val;
  }
  const numberVal = Number(val);
  let numberResult = 0;
  if (numberVal != val) {
    return val;
  }
  if (min === undefined && max === undefined) {
    return val;
  }
  if (max === undefined && min !== undefined) {
    numberResult = Math.max(numberVal, min);
  } else if (max !== undefined && min === undefined) {
    numberResult = Math.min(numberVal, max);
  } else {
    numberResult = Math.min(Math.max(numberVal, min!), max!);
  }
  return (isString ? `${numberResult}` : numberResult) as T;
};

export { getNumberLimit, MAX_INPUT_NUMBER, MIN_INPUT_NUMBER, editLimit };
